import { createAnnouncementRequest, listAnnouncementProps, updateAnnouncementRequest } from "../types/announcement";
import { getHotelId, headers, querystring, request } from "./lib/common";

export const listAnnouncement = ({ hotelId, name, offset, limit, pagination = true }: listAnnouncementProps) => {
  return request.get(`/multifamily/hotels/${hotelId ? hotelId : getHotelId()}/announcement`, {
    ...querystring({ ...(name && { name }), offset, limit, pagination }),
    ...headers({}),
  });
};

export const createAnnouncement = (item: createAnnouncementRequest) => {
  return request.post(`/multifamily/hotels/${getHotelId()}/announcement`, item, headers({}));
};

export const updateAnnouncement = (data: updateAnnouncementRequest) => {
  return request.put(`/multifamily/hotels/${getHotelId()}/announcement/${data.id}`, data, headers({}));
};

export const deleteAnnouncement = (id: number) => {
  return request.delete(`/multifamily/hotels/${getHotelId()}/announcement/${id}`, headers({}));
};
